// Junais 06-09-2022
import * as types from '../actions/appactiontypes'

const initialState={
    loadingIndicatorCounter:0,
    loadingIndicatorMessage:'',
    loadingIndicatorOptions:null,
     //
     preLoadingIndicatorCounter: 0,
     preLoadingIndicatorMessage: '',
     preLoadingIndicatorOptions: null,
     //
    message:'',
    messageOptions:null,
    messageCallback:null,
    errorCallback: null,
    errorResponse: null,


    userMenu:{
        menu:[
            {
                MenuType: 1,
                MenuId: 1,
                ParentMenuId: 0,
                DisplayName: "Medical Core",
            },
            {
                MenuType: 2,
                MenuId : 2,
                ParentMenuId: 1,
                DisplayName : "Core Policy"	
            },
            {
                MenuType: 3,
                MenuId : 3,
                ParentMenuId: 2,
                DisplayName : "New Policy 1"		
            },
            {
                MenuType: 1,
                MenuId : 4,
                ParentMenuId: 0,
                DisplayName : "Medical Portal"		
            },
            {
                MenuType: 2,
                MenuId : 5,
                ParentMenuId: 4,
                DisplayName : "Portal Policy"		
            },
            {
                MenuType: 3,
                MenuId : 6,
                ParentMenuId: 5,
                DisplayName : "New Policy 2"		
            }
        ]
    }
}
const appReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_LOADING: 
        let counter = action.value?state.loadingIndicatorCounter+1: state.loadingIndicatorCounter-1;
        counter=counter<0?0:counter;
            return {
               ...state,
               loadingIndicatorCounter: counter,
               loadingIndicatorMessage: action.loadingIndicatorMessage,
               loadingIndicatorOptions: action.loadingIndicatorOptions,
            };
        case types.SET_PRELOADING:
            let preCounter = action.value ? state.preLoadingIndicatorCounter + 1 : state.preLoadingIndicatorCounter - 1;
            preCounter = preCounter < 0 ? 0 : preCounter;
            return {
                ...state,
                preLoadingIndicatorCounter: preCounter,
                preLoadingIndicatorMessage: action.preLoadingIndicatorMessage,
                preLoadingIndicatorOptions: action.preLoadingIndicatorOptions,
            };
        case types.SET_MESSAGE:
            let {message, messageOptions, messageCallback} = action.payload;
            return{
                ...state,
                message: message,
                messageOptions: messageOptions,
                messageCallback: messageCallback
            }
            case types.CLOSE_MESSAGE:{
                return{
                    ...state,
                    message: '',
                    
                }
            }  
        case types.GET_USER_MENU_END: 
        return {
            ...state.userMenu,
            menu : action.payload,
        };
        default:
            return state;
    }
}

export default appReducer;